import { getApiBaseUrl } from '../../utils/environment.mjs';
import axios from 'axios';

const API_BASE_URL = getApiBaseUrl();


// Create axios instance with default config
const adminAPI = axios.create({
    baseURL: `${API_BASE_URL}/admin-action`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Handle response errors
adminAPI.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const adminSelectionService = {
    // Get admin profile
    getProfile: async () => {
        const response = await adminAPI.get('/profile');
        return response.data;
    },

    // Get users with pagination
    getUsers: async (page = 1, limit = 10) => {
        const response = await adminAPI.get(`/users?page=${page}&limit=${limit}`);
        return response.data;
    },

    // Get users by role
    getUsersByRole: async (role) => {
        const response = await adminAPI.get(`/users/role/${role}`);
        return response.data;
    },

    // Search users
    searchUsers: async (query) => {
        const response = await adminAPI.get(`/users/search?q=${encodeURIComponent(query)}`);
        return response.data;
    },

    // Get statistics
    getStats: async () => {
        const response = await adminAPI.get('/stats');
        return response.data;
    },

    // Promote user to admin
    promoteUser: async (userId) => {
        const response = await adminAPI.patch(`/users/${userId}/promote`);
        return response.data;
    },

    // Demote admin to user
    demoteUser: async (userId) => {
        const response = await adminAPI.patch(`/users/${userId}/demote`);
        return response.data;
    },
};